import { startLogRocket } from './logRocket';
import { getCookie } from '../utils/domUtils';

declare global {
  interface Window {
    fetchOnesignal: Function;
    fetchFullstory: Function;
    fetchFacebook: Function;
    fetchLinkedin: Function;
    fetchPardot: Function;
    fetchTwitter: Function;
    fbq: any | undefined;
  }
}

export function startProviders() {
  try {
    const cookieString: string = getCookie('cookies_policy');
    if (cookieString) {
      startLogRocket();
      window.fetchOnesignal();
      window.fetchFullstory();
      window.fetchFacebook();
      window.fetchLinkedin();
      window.fetchPardot();
      window.fetchTwitter();
    }
    if (window.fbq && window.page_name === 'Signup') {
      /* 
        Redundancy of this event with SignUpLayout
        component does not communicate with cookie acceptance
        triggers pixel if cookie is accepted on the page
      */
      window.fbq('track', 'ViewContent');
    }
  } catch (error) {
    console.log(error);
  }
}
